// extracted by mini-css-extract-plugin
export var wrap = "feedback-module--wrap--gw9FQ";
export var head = "feedback-module--head--UI1dL";
export var head_svg = "feedback-module--head_svg--1o4X8";
export var swiper = "feedback-module--swiper--1eqRs";
export var jsAnimInit = "feedback-module--jsAnimInit--3at0b";